import { Component, OnInit, ViewChild, TemplateRef, OnDestroy} from '@angular/core';
import { AuthorizeService } from '../../service/authorize.service';
import { StoreService } from '../../service/store.service';
import { Router } from '@angular/router';
import { BsModalRef, BsModalService } from 'ngx-bootstrap';
import { CrmScreenComponent } from '../../crm/crm-screen/crm-screen.component';
import { ToastrService } from 'ngx-toastr';
@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss']
})
export class SidebarComponent implements OnInit, OnDestroy {
  @ViewChild('templateSaved') templateSaved: TemplateRef<any>
  @ViewChild(CrmScreenComponent) crmComponent: CrmScreenComponent
  inputOpenCase = false
  notCrm = false
  modalRef: BsModalRef
  modalConfig: {
    animated: true
    keyboard: true
    backdrop: true
    ignoreBackdropClick: true
  }
  message = 'Do you want to leave this page without saving data?'
  pathForLink
  marketLevel = '/market-level/market-level'
  compareExchange = '/market-level/compare-exchanges'
  industryLevel = '/industry-level/industry-level'
  executiveSum = '/securities-level/excecutive-summary'
  financial = '/securities-level/financial'
  trading = '/securities-level/trading'
  corporateAction = '/securities-level/corporateaction'
  revenueContribution = '/securities-level/revenuecontribution'
  crm = '/crm/crm'
  adminAE = 'admin/admin'
  constructor(
    private authorization: AuthorizeService,
    private store: StoreService,
    private router: Router,
    private modalService: BsModalService,
    private toastr: ToastrService,
  ) { }

  ngOnInit() {
    this.store.getInputOpenObservable().subscribe(inputOpen => {
      this.inputOpenCase = inputOpen
    })
  }
  click(path) {
    this.pathForLink = path
    if (this.inputOpenCase && this.router.url.indexOf('crm') > 0) {
      this.openModal(this.templateSaved)
      this.router.navigate(['/crm/crm'])
    } else {
      this.router.navigate([path])
    }
  }

  get firstNameEng(): String {
    return this.authorization.getUserFirstNameEng();
  }

  get isUserHasAdminPermission(): Boolean {
    return this.authorization.hasRole('ROLE_ADMIN');
  }
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(
      template,
      Object.assign({}, this.modalConfig, { class: 'modal-sm' })
    )
  }
  closeModal() {
    this.router.navigate([this.pathForLink])
    this.inputOpenCase = false
    this.modalRef.hide()
  }
  goBack() {
    this.modalRef.hide()
  }
  ngOnDestroy(): void {
    this.store.setInputOpenBehavior(false)
  }
}



// WEBPACK FOOTER //
// /opt/alm/jenkins/workspace/mis-cpm/mis-cpm-prod-front/src/app/layouts/sidebar/sidebar.component.ts